import moment from "moment";

const ATALogo = "https://s3.eu-west-1.amazonaws.com/aryabhattadev.quloi.com/build/logo_ata_email.png"
const pdfIcon = "https://s3.eu-west-1.amazonaws.com/aryabhattadev.quloi.com/build/pdfIcon_email.png"

export const getPlanUplaodEmailBodyForTractor = (planOf, plan, shipment) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
          <div style="width: 100%; background-color: transparent; line-height: inherit;">
            <div>
            <span>Dear Team,</span>
            <p>${planOf} daily plan for ${moment(plan).format("DD-MM-YYYY")} has been uploaded in aryabhatta.</p>
            <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Market</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Variant</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Quantity</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">SI</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Remark</th>
                    </tr>
                    ${shipment.map((item) => {
                      var marketData = item.Market ? item.Market : "";
                      var varientData = item.Variant
                        ? item.Variant
                        : "";
                      var quantityData = item.Quantity ? item.Quantity : "";
                      var ContainerData = item.Container
                        ? item.Container
                        : 0;
                      var CountryData = item.Country ? item.Country : "";
                      var SIData = item.SI ? item.SI : "";

                      var RemarkData = item.Remark ? item.Remark : "";
                      return `
                      <tr>
                      <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${marketData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${varientData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${quantityData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${ContainerData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${CountryData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${SIData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                        ${RemarkData}
                      </td>
                      </tr>`;
                    }).join(" ")}
                </table>
            <div style='width: 100%; background-color: transparent; line-height: inherit;' >
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
                <img src=${ATALogo} alt="p" />
            </div>
        </div>
        </div>`;
};

export const getPlanUplaodEmailBodyForAggregate = (planOf, plan, shipment) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
          <div style="width: 100%; background-color: transparent; line-height: inherit;">
            <div>
            <span>Dear Team,</span>
            <p>${planOf} daily plan for ${moment(plan).format("DD-MM-YYYY")} has been uploaded in aryabhatta.</p>
            <table style="border: 1px solid black;border-collapse: collapse; overflow-x: auto">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Part Number</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Category</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Sub Category</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Quantity</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container Type</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Remark</th>
                    </tr>
                    ${shipment.map((item) => {
                      var PartNumberData = item["Part Number"] ? item["Part Number"] : "";
                      var CategoryData = item.Category
                        ? item.Category
                        : "";
                        var CountryData = item.Country ? item.Country : "";
                        var SubCategoryData = item["Sub Category"] ? item["Sub Category"] : "";
                      var quantityData = item.Quantity ? item.Quantity : "";
                      var ContainerData = item.Container
                        ? item.Container
                        : 0;
                      var ContainerTypeData = item["Container Type"] ? item["Container Type"] : "";

                      var RemarkData = item.Remark ? item.Remark : "";
                      return `
                      <tr>
                      <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${PartNumberData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${CategoryData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${CountryData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${SubCategoryData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${quantityData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${ContainerData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                        ${ContainerTypeData}
                      </td>
                      <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                        ${RemarkData}
                      </td>
                      </tr>`;
                    }).join(" ")}
                </table>
            <div style='width: 100%; background-color: transparent; line-height: inherit;' >
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
                <img src=${ATALogo} alt="p" />
            </div>
        </div>
        </div>`;
};

export const getPlanUplaodEmailBodyForFiveM = (planOf, plan, shipment) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
          <div style="width: 100%; background-color: transparent; line-height: inherit;">
            <div>
            <span>Dear Team,</span>
            <p>${planOf} daily plan for ${moment(plan).format("DD-MM-YYYY")} has been uploaded in aryabhatta.</p>
            <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Market</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Variant</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Quantity</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container Type</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">SI</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Remark</th>
                    </tr>
                    ${shipment.map((item) => {
                      var marketData = item.Market ? item.Market : "";
                      var CountryData = item.Country ? item.Country : "";
                      var varientData = item.Variant
                        ? item.Variant
                        : "";
                      var quantityData = item.Quantity ? item.Quantity : "";
                      var ContainerData = item.Container
                        ? item.Container
                        : 0;
                      var ContainerTypeData = item["Container Type"] ? item["Container Type"] : "";
                      var SIData = item.SI ? item.SI : "";

                      var RemarkData = item.Remark ? item.Remark : "";
                      return `
                      <tr>
                      <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${marketData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                            ${CountryData}
                          </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${varientData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${quantityData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${ContainerData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${ContainerTypeData}
                  </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${SIData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                        ${RemarkData}
                      </td>
                      </tr>`;
                    }).join(" ")}
                </table>
            <div style='width: 100%; background-color: transparent; line-height: inherit;' >
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
                <img src=${ATALogo} alt="p" />
            </div>
        </div>
        </div>`;
};

export const getDeleteDataShipmentForTractor = (planOf, plan, shipment, type) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
          <div style="width: 100%; background-color: transparent; line-height: inherit;">
            <div>
            <span>Dear Team,</span>
            <p>${planOf} ${type} plan for ${moment(plan).format("DD-MM-YY")} has been deleted in aryabhatta.</p>
            <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Market</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Variant</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Quantity</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container Type</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">SI</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Remark</th>
                    </tr>
                    ${shipment.map((item) => {
                      var marketData = item.Market ? item.Market : "";
                      var varientData =  item.Varient_PartNumber
                        ? item.Varient_PartNumber
                        : "";
                      var quantityData = item.Quantity ? item.Quantity : "";
                      var ContainerData = item.Container_Count
                        ? item.Container_Count
                        : 0;
                      var ContainerTypeData = item["Container_Type"] ? item["Container_Type"] : "";
                      var CountryData = item.Country ? item.Country : "";
                      var SIData = item.SI ? item.SI : "";

                      var RemarkData = item.Remark ? item.Remark : "";
                      return `
                      <tr>
                      <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${marketData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${varientData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${quantityData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${ContainerData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${ContainerTypeData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${CountryData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${SIData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                        ${RemarkData}
                      </td>
                      </tr>`;
                    }).join(" ")}
                </table>
            <div style='width: 100%; background-color: transparent; line-height: inherit;' >
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
                <img src=${ATALogo} alt="p" />
            </div>
        </div>
        </div>`;
};

export const getDeleteDataShipmentForAggregate = (planOf, plan, shipment, type) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
          <div style="width: 100%; background-color: transparent; line-height: inherit;">
            <div>
            <span>Dear Team,</span>
            <p>${planOf} ${type} plan for ${moment(plan).format("DD-MM-YY")} has been deleted in aryabhatta.</p>
            <table style="border: 1px solid black;border-collapse: collapse; overflow-x: auto">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Part Number</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Category</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Sub Category</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Quantity</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container Type</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Remark</th>
                    </tr>
                    ${shipment.map((item) => {
                      var PartNumberData = item["PartNumber"] ? item["PartNumber"] : "";
                      var CategoryData = item.Category
                        ? item.Category
                        : "";
                        var CountryData = item.Country ? item.Country : "";
                        var SubCategoryData = item["SubCategory"] ? item["SubCategory"] : "";
                      var quantityData = item.Quantity ? item.Quantity : "";
                      var ContainerData = item.Container_Count
                        ? item.Container_Count
                        : 0;
                      var ContainerTypeData = item["Container_Type"] ? item["Container_Type"] : "";

                      var RemarkData = item.Remark ? item.Remark : "";
                      return `
                      <tr>
                      <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${PartNumberData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${CategoryData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${CountryData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${SubCategoryData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${quantityData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${ContainerData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                        ${ContainerTypeData}
                      </td>
                      <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                        ${RemarkData}
                      </td>
                      </tr>`;
                    }).join(" ")}
                </table>
            <div style='width: 100%; background-color: transparent; line-height: inherit;' >
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
                <img src=${ATALogo} alt="p" />
            </div>
        </div>
        </div>`;
};

export const getDeleteDataShipmentFor5M = (planOf, plan, shipment, type) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
          <div style="width: 100%; background-color: transparent; line-height: inherit;">
            <div>
            <span>Dear Team,</span>
            <p>${planOf} ${type} plan for ${moment(plan).format("DD-MM-YY")} has been deleted in aryabhatta.</p>
            <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Market</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Variant</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Quantity</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Container Type</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">SI</th>
                        <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Remark</th>
                    </tr>
                    ${shipment.map((item) => {
                      var marketData = item.Market ? item.Market : "";
                      var varientData =  item.Variant
                        ? item.Variant
                        : "";
                      var quantityData = item.Quantity ? item.Quantity : "";
                      var ContainerData = item.Container_Count
                        ? item.Container_Count
                        : 0;
                      var ContainerTypeData = item["Container_Type"] ? item["Container_Type"] : "";
                      var CountryData = item.Country ? item.Country : "";
                      var SIData = item.SI ? item.SI : "";

                      var RemarkData = item.Remark ? item.Remark : "";
                      return `
                      <tr>
                      <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${marketData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                      ${varientData}
                    </td>
                    <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${quantityData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${ContainerData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                    ${ContainerTypeData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${CountryData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                          ${SIData}
                        </td>
                        <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center;">
                        ${RemarkData}
                      </td>
                      </tr>`;
                    }).join(" ")}
                </table>
            <div style='width: 100%; background-color: transparent; line-height: inherit;' >
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
                <img src=${ATALogo} alt="p" />
            </div>
        </div>
        </div>`;
};

export const getDeleteMonthlyDataShipment = (planOf, plan, type) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
          <div style="width: 100%; background-color: transparent; line-height: inherit;">
            <div>
            <span>Dear Team,</span>
            <p>${planOf} ${type} plan for ${moment(plan).format("MMM-YY")} has been deleted in aryabhatta.</p>
            <div style='width: 100%; background-color: transparent; line-height: inherit;' >
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
                <img src=${ATALogo} alt="p" />
            </div>
        </div>
        </div>`;
};

export const getBookingBody = (shipment, typeOfShipment, BookingNo) => {
  if (typeOfShipment === "Tractor") {
    return `<div style="margin: 0px auto; min-width: 320px; max-width: 550px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
            <div style="width: 100%; background-color: transparent; line-height: inherit;">
              <div>
                <span>Dear Team,</span>
                </br>
                <p>Tractor booking has been done for following shipment</p>
                <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse;">Market</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Varient</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Port of destination</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Booking number</th>
                    </tr>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Market}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Varient_PartNumber}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Country}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Port_Of_Destination}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${BookingNo}</td>
                </table>
              </div>
              <div style="margin-top: 30px;margin-bottom: -30px;">
                Thanks and Regards,
              </div>
              <img src=${ATALogo} alt="p" />
            </div>
          </div>`;
  } else if (typeOfShipment === "Aggregate") {
    return `<div style="margin: 0px auto; min-width: 320px; max-width: 550px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
            <div style="width: 100%; background-color: transparent; line-height: inherit;">
              <div>
                <span>Dear Team,</span>
                </br>
                <p>Aggregate booking has been done for following shipment</p>
                <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Port of destination</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Part number</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Category</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Sub category</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Booking number</th>
                    </tr>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Country}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Port_Of_Destination}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.PartNumber}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Category}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.SubCategory}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${BookingNo}</td>
                </table>
              </div>
              <div style="margin-top: 30px;margin-bottom: -30px;">
                Thanks and Regards,
              </div>
              <img src=${ATALogo} alt="p" />
            </div>
          </div>`;
  } else if (typeOfShipment === "FiveM") {
    return `<div style="margin: 0px auto; min-width: 320px; max-width: 550px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
            <div style="width: 100%; background-color: transparent; line-height: inherit;">
              <div>
                <span>Dear Team,</span>
                </br>
                <p>5M booking has been done for following shipment</p>
                <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Port of destination</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Market</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Varient</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Booking number</th>
                    </tr>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Country}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Port_Of_Destination}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Market}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Variant}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${BookingNo}</td>
                </table>
              </div>
              <div style="margin-top: 30px;margin-bottom: -30px;">
                Thanks and Regards,
              </div>
              <img src=${ATALogo} alt="p" />
            </div>
          </div>`;
  }
};

export const getSIUploadBody = (planMonth) => {
  return `<div style='margin: 0px auto; min-width: 320px; max-width: 550px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;' >
            <span>Dear Team,</span>
            <p>SI documents for month ${planMonth} has been uploaded in aryabhatta.</p>
            <div style='width: 100%; background-color: transparent; line-height: inherit;' >
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
                <img src=${ATALogo} alt="p" />
            </div>
        </div>`;
};

export const jdResponseMailBody = (shipment, typeOfShipment, status) => {
  if (typeOfShipment === "Tractor") {
    return `<div style="margin: 0px auto; min-width: 320px; max-width: 550px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
            <div style="width: 100%; background-color: transparent; line-height: inherit;">
              <div>
                <span>Dear Team,</span>
                </br>
                <p>Tractor planning status has been updated for following shipment</p>
                <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse;">Market</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Varient</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Port of destination</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Status</th>
                    </tr>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Market}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Varient_PartNumber}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Country}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Port_Of_Destination}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${status}</td>
                </table>
              </div>
                <div style="margin-top: 30px;margin-bottom: -30px;">
                  Thanks and Regards,
                </div>
              <img src=${ATALogo} alt="p" />
            </div>
          </div>`;
  } else if (typeOfShipment === "Aggregate") {
    return `<div style="margin: 0px auto; min-width: 320px; max-width: 550px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
            <div style="width: 100%; background-color: transparent; line-height: inherit;">
              <div>
                <span>Dear Team,</span>
                </br>
                <p>Aggregate planning status has been updated for following shipment</p>
                <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Port of destination</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Part number</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Category</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Sub category</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Status</th>
                    </tr>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Country}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Port_Of_Destination}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.PartNumber}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Category}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.SubCategory}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${status}</td>
                </table>
              </div>
              <div style="margin-top: 30px;margin-bottom: -30px;">
                Thanks and Regards,
              </div>
              <img src=${ATALogo} alt="p" />
            </div>
          </div>`;
  } else if (typeOfShipment === "FiveM") {
    return `<div style="margin: 0px auto; min-width: 320px; max-width: 550px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
            <div style="width: 100%; background-color: transparent; line-height: inherit;">
              <div>
                <span>Dear Team,</span>
                </br>
                <p>5M planning status has been updated for following shipment</p>
                <table style="border: 1px solid black;border-collapse: collapse;">
                    <tr>
                        <th style="border: 1px solid black;border-collapse: collapse;">Country</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Port of destination</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Market</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Varient</th>
                        <th style="border: 1px solid black;border-collapse: collapse;">Status</th>
                    </tr>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Country}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Port_Of_Destination}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Market}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${shipment.Variant}</td>
                    <td style="border: 1px solid black;border-collapse: collapse;">${status}</td>
                </table>
              </div>
              <div style="margin-top: 30px;margin-bottom: -30px;">
                Thanks and Regards,
              </div>
              <img src=${ATALogo} alt="p" />
            </div>
          </div>`;
  }
};

export const pickupPlanMailBodyForJD = (shipment) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
    <div style="width: 100%; background-color: transparent; line-height: inherit;">
      <div>
        <span>Dear Team,</span>
        </br>
        <p>Please find below booking status for next plan. Please advise confirmation on container pickup.</p>
        </br>
        <table style="border: 1px solid black;border-collapse: collapse; overflow-x: scroll;">
            <tr>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">POD</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 700px; background-color: orange;">20GP</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 700px; background-color: orange;">40HC</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Transporter</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Module</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">BKG NO</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Reason</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">S-LINE</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2000px; background-color: orange;">JD Stuffing</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">ETD</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Grd. Rnt. Days</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Origin T/T</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Approx. Cont. detention.</th>
            </tr>
            ${shipment.map((item) => {
              var GPContainerQty =
                item.Container_Type === "20GP" ? item.Container_Count : "";
              var HCContainerQty =
                item.Container_Type === "40HC" ? item.Container_Count : "";
              var countryData = item.Country ? item.Country : "";
              var filterPOD = item.Port_Of_Destination
                ? item.Port_Of_Destination
                : "";
                var reasonData = !item.Booking_Number?(item.Reason ? item.Reason : ""):"";
                var transporterData = item.Transporter ? item.Transporter : "";
              var BookingNumberData = item.Booking_Number
                ? item.Booking_Number
                : "";
              var CarrierData = item.Carrier ? item.Carrier : "";
              var JDStuffingDateData =
                item.JD_Stuffing_Date !== "Invalid date"
                  ? item.JD_Stuffing_Date
                  : "";
              var ETDData =
                item.ETD !== "Invalid date"
                  ? moment(item.ETD).format("DD-MM-YY")
                  : "";
              var GroundRentDaysData = item.Ground_Rent_Days
                ? item.Ground_Rent_Days
                : "";
              var OriginTransitTimeData = item.Origin_Transit_Time
                ? item.Origin_Transit_Time
                : "";
              var ApproxContainerDetentionData = item.Approx_container_detention
                ? item.Approx_container_detention
                : "";
              var ModuleData = item.DataOf ? item.DataOf : "";
              return `
              <tr>
              <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
              ${countryData}
            </td>
            <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
              ${filterPOD}
            </td>
            <td style="border: 1px solid black;border-collapse: collapse; width: 100px; text-align: center; font-size:14px">
            ${GPContainerQty}
          </td>
          <td style="border: 1px solid black;border-collapse: collapse; width: 100px; text-align: center; font-size:14px">
            ${HCContainerQty}
          </td>
          <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                  ${transporterData}
                </td>
                <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                  ${ModuleData}
                </td>
                <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                ${BookingNumberData}
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                ${reasonData}
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                ${CarrierData}
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                ${JDStuffingDateData}
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
              ${ETDData}
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                ${GroundRentDaysData}
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                ${OriginTransitTimeData}
              </td>
              <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                ${ApproxContainerDetentionData}
              </td>
              </tr>`;
            }).join(" ")}
        </table>
      </div>
      <div style="margin-top: 30px;margin-bottom: -30px;">
        Thanks and Regards,
      </div>
      <img src=${ATALogo} alt="p" />
    </div>
  </div>`;
};

export const pickupPlanMailBodyForTransporter = (shipment) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
    <div style="width: 100%; background-color: transparent; line-height: inherit;">
      <div>
        <span>Dear Team,</span>
        </br>
        <p>Please find attached booking for JD stuffing - ${shipment[0].JD_Stuffing_Date}
        </br>
        Note – Vehicle should reach JD Factory before 7:00 Am without fail. 
        </br>
        For factory-hold vehicles, detention will be applicable after 24 HRs. 
        </br>
        Driver should have mobile for contact & valid documents (Valid Documents copy like Driving License, PUC, Insurance Copy, Vaccination Certificate etc.) & Also, Driver should not consume alcohol & Drive.
        </br>
         
        Note – Weak & Patch Flooring containers are not allowed.
        </p>
        <table style="border: 1px solid black;border-collapse: collapse; overflow-x: scroll;">
            <tr>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">POD</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 700px; background-color: orange;">20GP</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 700px; background-color: orange;">40HC</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2000px; background-color: orange;">Transporter</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Module</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">BKG NO</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Reason</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">S-LINE</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2000px; background-color: orange;">JD Stuffing</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">Booking Copy</th>
            </tr>
            ${shipment.map((item) => {
              var GPContainerQty =
                item.Container_Type === "20GP" ? item.Container_Count : "";
              var HCContainerQty =
                item.Container_Type === "40HC" ? item.Container_Count : "";

              var bookingData = item.BookingDocument
                ? item.BookingDocument
                : "";
              var bookingLink = item.bookingDocLink
              ? item.bookingDocLink
              : "";

              var countryData = item.Country ? item.Country : "";
              var reasonData = !item.Booking_Number?(item.Reason ? item.Reason : ""):"";
              var filterPOD = item.Port_Of_Destination
                ? item.Port_Of_Destination
                : "";
              var transporterData = item.Transporter ? item.Transporter : "";
              var BookingNumberData = item.Booking_Number
                ? item.Booking_Number
                : "";
              var CarrierData = item.Carrier ? item.Carrier : "";
              var JDStuffingDateData =
                item.JD_Stuffing_Date !== "Invalid date"
                  ? item.JD_Stuffing_Date
                  : "";
              var ModuleData = item.DataOf ? item.DataOf : "";
              return `<tr>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${countryData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${filterPOD}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 100px; text-align: center; font-size:14px">
                  ${GPContainerQty}
                </td>
                <td style="border: 1px solid black;border-collapse: collapse; width: 100px; text-align: center; font-size:14px">
                  ${HCContainerQty}
                </td>
                <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                  ${transporterData}
                </td>
                <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                ${ModuleData}
                </td>
                <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${BookingNumberData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${reasonData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${CarrierData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                  ${JDStuffingDateData}
                  </td>
                  <td style="border: 1px solid black; border-collapse: collapse; width: 200px; text-align: center;">
                    ${bookingData && `<a href=${bookingLink}>
                      <img src=${pdfIcon} alt="Img" style="width: 50px; height: 50px" />
                    </a>`}
                  </td>
                </tr>`;
            }).join(" ")}
        </table>
      </div>
      <div style="margin-top: 30px;margin-bottom: -30px;">
        Thanks and Regards,
      </div>
      <img src=${ATALogo} alt="ATA Logo" />
    </div>
  </div>`;
};

export const pickupPlanMailBodyForFactory = (
  shipment
) => {
  return `<div style="margin-top: 0px; margin-left: 10px; min-width: 320px; max-width: 1200px; overflow-wrap: break-word; word-break: break-word; background-color: transparent; line-height: inherit;">
    <div style="width: 100%; background-color: transparent; line-height: inherit;">
      <div>
        <span>Dear Team,</span>
        </br>
        <p>
        Please find below details of ETA ETD for your reference.
        </p>
        </br>
        <table style="border: 1px solid black;border-collapse: collapse; overflow-x: scroll;">
            <tr>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Country</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">POD</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2300px; background-color: orange;">FINAL DESTINATION</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">ETD</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">ETA</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Module</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">VSL / Voy-</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">S-LINE</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 2000px; background-color: orange;">JD Stuffing</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 700px; background-color: orange;">20GP</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 700px; background-color: orange;">40HC</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">BKG NO</th>
                <th style="border: 1px solid black;border-collapse: collapse; width: 1200px; background-color: orange;">Reason</th>
            </tr>
            ${shipment.map((item) => {
              var GPContainerQty =
                item.Container_Type === "20GP" ? item.Container_Count : "";
              var HCContainerQty =
                item.Container_Type === "40HC" ? item.Container_Count : "";

              var countryData = item.Country ? item.Country : "";
              var filterPOD = item.Port_Of_Destination
                ? item.Port_Of_Destination
                : "";
              var filterFinalDestination = item.final_destination
                ? item.final_destination
                : "";
              var ETDData =
                item.ETD !== "Invalid date"
                  ? moment(item.ETD).format("DD-MM-YY")
                  : "";
              var ETAData =
                item.ETA !== "Invalid date"
                  ? moment(item.ETA).format("DD-MM-YY")
                  : "";
              var VSL_VOYData = item.VSL_VOY ? item.VSL_VOY : "";
              var reasonData = !item.Booking_Number?(item.Reason ? item.Reason : ""):"";
              var CarrierData = item.Carrier ? item.Carrier : "";
              var JDStuffingDateData =
                item.JD_Stuffing_Date !== "Invalid date"
                  ? item.JD_Stuffing_Date
                  : "";
              var BookingNumberData = item.Booking_Number
                ? item.Booking_Number
                : "";
              var ModuleData = item.DataOf ? item.DataOf : "";
              return `
                  <tr>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${countryData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${filterPOD}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${filterFinalDestination}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                  ${ETDData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                  ${ETAData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                  ${ModuleData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${VSL_VOYData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${CarrierData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                  ${JDStuffingDateData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 100px; text-align: center; font-size:14px">
                    ${GPContainerQty}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 100px; text-align: center; font-size:14px">
                    ${HCContainerQty}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${BookingNumberData}
                  </td>
                  <td style="border: 1px solid black;border-collapse: collapse; width: 1200px; text-align: center; font-size:14px">
                    ${reasonData}
                  </td>
                  </tr>`;
            }).join(" ")}
        </table>
      </div>
      <div style="margin-top: 30px;margin-bottom: -30px;">
        Thanks and Regards,
      </div>
      <img src=${ATALogo} alt="p" />
    </div>
  </div>`;
};
